import { IconCalendarClock } from '@tabler/icons-react';
import type { BlockDefinition } from '@/components/canvas/blocks/registry/types';
import { registerBlockDefinition } from '@/components/canvas/blocks/registry/blockRegistry';
import type { CutdownCardBlock } from '@/components/canvas/blocks/types';
import { createCutdownCardBlock } from '@/components/canvas/blocks/cutdown-card/createCutdownCardBlock';
import { estimateCutdownCardContentSize } from '@/components/canvas/blocks/cutdown-card/contentMetrics';
import { CutdownCardBlockView } from '@/components/canvas/blocks/cutdown-card/CutdownCardBlockView';
import { CutdownCardProperties } from '@/components/canvas/blocks/cutdown-card/CutdownCardProperties';

const DEFAULT_WIDTH = 320;
const DEFAULT_HEIGHT = 80;

export const cutdownCardBlockDefinition: BlockDefinition<CutdownCardBlock> = {
  type: 'cutdown-card',
  label: '倒计时卡',
  defaultSize: { width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT },
  minSize: { width: 80, height: 40 },
  create: (ctx) =>
    createCutdownCardBlock({
      id: ctx.id,
      x: ctx.x,
      y: ctx.y,
      width: ctx.width,
      height: ctx.height,
      zIndex: ctx.zIndex,
      name: ctx.name,
    }),
  estimateContentSize: (data) => estimateCutdownCardContentSize(data),
  View: CutdownCardBlockView,
  Properties: CutdownCardProperties,
  menuItem: {
    type: 'cutdown-card',
    label: '卡片倒计时',
    Icon: IconCalendarClock,
  },
};

registerBlockDefinition(cutdownCardBlockDefinition);
